(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["make-your-own-combo"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const builders = document.querySelectorAll('[data-combo-builder]');

    builders.forEach((builder) => {
      if (builder.dataset.initialized === 'true') return;
      builder.dataset.initialized = 'true';

      const form = builder.querySelector('.combo-builder__form');
      if (!form) return;

      const checkboxes = Array.from(builder.querySelectorAll('.combo-card__checkbox'));
      const button = builder.querySelector('.combo-builder__button');
      const buyNowButton = builder.querySelector('.combo-builder__buy-now');
      const count = builder.querySelector('[data-selected-count]');
      const total = builder.querySelector('[data-combo-total]');
      const status = builder.querySelector('[data-status]');
      const discount = Number(builder.dataset.discountCents || 0);
      const formatter = new Intl.NumberFormat(builder.dataset.locale || 'en-IN', {
        style: 'currency',
        currency: builder.dataset.currency || 'INR'
      });

      const selectedCards = () => checkboxes.filter((checkbox) => checkbox.checked).map((checkbox) => checkbox.closest('.combo-card'));

      const update = () => {
        const cards = selectedCards();
        count.textContent = String(cards.length);
        button.disabled = cards.length !== 2;
        buyNowButton.disabled = cards.length !== 2;
        checkboxes.forEach((checkbox) => {
          checkbox.disabled = !checkbox.checked && cards.length >= 2;
        });

        if (cards.length === 2) {
          const subtotal = cards.reduce((sum, card) => {
            const variant = card.querySelector('.combo-card__variant');
            const option = variant.matches('select') ? variant.selectedOptions[0] : variant;
            return sum + Number(option.dataset.price || 0);
          }, 0);
          total.textContent = `${formatter.format(Math.max(0, subtotal - discount) / 100)} ${builder.dataset.totalSuffix}`;
        } else {
          total.textContent = builder.dataset.chooseMessage;
        }
        status.textContent = '';
      };

      checkboxes.forEach((checkbox) => checkbox.addEventListener('change', update));

      builder.querySelectorAll('.combo-card__variant').forEach((variant) => {
        variant.addEventListener('change', () => {
          const card = variant.closest('.combo-card');
          const checkbox = card.querySelector('.combo-card__checkbox');
          const option = variant.selectedOptions[0];
          checkbox.value = option.value;
          card.querySelector('[data-price-output]').textContent = formatter.format(Number(option.dataset.price || 0) / 100);
          update();
        });
      });

      const addCombo = async (goToCheckout) => {
        const cards = selectedCards();
        if (cards.length !== 2) {
          status.textContent = builder.dataset.errorMessage;
          return;
        }

        const activeButton = goToCheckout ? buyNowButton : button;
        button.disabled = true;
        buyNowButton.disabled = true;
        activeButton.classList.add('is-loading');
        status.textContent = '';

        const comboGroup = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
        const items = cards.map((card) => ({
          id: Number(card.querySelector('.combo-card__checkbox').value),
          quantity: 1,
          properties: {
            '_Combo offer': 'Make your own combo — ₹200 off',
            '_Combo group': comboGroup
          }
        }));

        try {
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          if (goToCheckout) {
            window.location.assign(`${window.Shopify.routes.root}cart`);
            return;
          }
          checkboxes.forEach((checkbox) => {
            checkbox.checked = false;
          });
          activeButton.classList.remove('is-loading');
          update();
          status.textContent = builder.dataset.successMessage;
        } catch (error) {
          status.textContent = builder.dataset.errorMessage;
          activeButton.classList.remove('is-loading');
          update();
        }
      };

      form.addEventListener('submit', (event) => {
        event.preventDefault();
        addCombo(false);
      });

      buyNowButton.addEventListener('click', () => addCombo(true));

      update();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
